<template>
  <div class="container-custom">
    <!-- BreadScrumbs -->
    <BreadScrumbs
      :links="[{ name: 'Investor', to: { path: '/investor-faq' } }]"
    ></BreadScrumbs>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>Investor FAQ</h2>
      <v-spacer></v-spacer>
      <button class="btn btn-primary" @click="createHandler">
        <v-icon class="pr-2 white--text">add</v-icon>
        <span>新增FAQ</span>
      </button>
    </div>
    <!--  -->
    <InvestorFAQTable class="mb-5"></InvestorFAQTable>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import BreadScrumbs from '@/components/Breadscrumbs.vue';
import InvestorFAQTable from '@/views/I-1__IR-InvestorFAQ/c/InvestorFAQTable.vue';

export default {
  components: {
    BreadScrumbs,
    InvestorFAQTable,
  },
  created() {
    this.clear();
    this.getShareholderFaqs();
  },
  methods: {
    ...mapActions('shareholderFaq', {
      getShareholderFaqs: 'find',
      clear: 'clear',
    }),
    createHandler() {
      this.$router.push('/investor-faq/create');
    },
    toEditPageTitle() {
      this.$router.push('/investor-faq/edit-investor-faq-page-title');
    },
  },
};
</script>

<style></style>
